var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w100 pt20 pb20 pl20 pr20 bg-w"},[_vm._v("自定义服务")])}
var staticRenderFns = []

export { render, staticRenderFns }